import { supabaseAuth } from './supabaseAuth'
import type { AuthBackend } from './types'

/** Signing in, against Supabase. */
export const authBackend: AuthBackend = supabaseAuth

export * from './types'
